import { supabase } from '@/lib/supabase/client';
import type { Database } from '@/lib/supabase/types';

type NotificationRow = Database['public']['Tables']['notifications']['Row'];
export type Notification = NotificationRow;
export type NotificationKind = Database['public']['Enums']['notification_kind'];

/** List notifications for the recipient profile, newest first. */
export async function listNotifications(
  recipientId: string,
  limit = 30,
): Promise<Notification[]> {
  const { data, error } = await supabase
    .from('notifications')
    .select(
      'id, recipient_id, actor_id, kind, entity_type, entity_id, read_at, created_at',
    )
    .eq('recipient_id', recipientId)
    .order('created_at', { ascending: false })
    .limit(limit)
    .throwOnError();
  if (error) throw error;
  return data ?? [];
}

/** Count unread notifications for the recipient profile. */
export async function countUnread(recipientId: string): Promise<number> {
  const { count, error } = await supabase
    .from('notifications')
    .select('id', { count: 'exact', head: true })
    .eq('recipient_id', recipientId)
    .is('read_at', null)
    .throwOnError();
  if (error) throw error;
  return count ?? 0;
}

/** Mark a single notification as read. */
export async function markRead(notificationId: string): Promise<void> {
  const { error } = await supabase
    .from('notifications')
    .update({ read_at: new Date().toISOString() })
    .eq('id', notificationId)
    .throwOnError();
  if (error) throw error;
}

/** Mark all notifications for a recipient as read. */
export async function markAllRead(recipientId: string): Promise<void> {
  const { error } = await supabase
    .from('notifications')
    .update({ read_at: new Date().toISOString() })
    .eq('recipient_id', recipientId)
    .is('read_at', null)
    .throwOnError();
  if (error) throw error;
}
